/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownLeftIcon24Regular = forwardRef('ArrowDCornerDownLeftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M17 15.875A3.875 3.875 0 0 0 20.875 12V3a.875.875 0 1 0-1.75 0v9A2.125 2.125 0 0 1 17 14.125H5.112l5.257-5.256A.875.875 0 1 0 9.13 7.63l-5.504 5.504a2.638 2.638 0 0 0 0 3.73l5.504 5.504a.875.875 0 1 0 1.238-1.238l-5.257-5.256H17Z" })));
});
